import UsedGifts from '../../components/pages/mypages/UsedGifts.vue'
export default {
  components: { UsedGifts }
}
